import { render } from "./module-modal.vue?vue&type=template&id=41c367b2"
import script from "./module-modal.vue?vue&type=script&lang=js"
export * from "./module-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__